/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown>, suffix: NonNullable<unknown> }} Audio_Recorder_Recording_Starts_InInputs */

const en_audio_recorder_recording_starts_in = /** @type {(inputs: Audio_Recorder_Recording_Starts_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Recording starts in ${i?.seconds} second${i?.suffix}`)
};

const fr_audio_recorder_recording_starts_in = /** @type {(inputs: Audio_Recorder_Recording_Starts_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'enregistrement commence dans ${i?.seconds} seconde${i?.suffix}`)
};

const de_audio_recorder_recording_starts_in = /** @type {(inputs: Audio_Recorder_Recording_Starts_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die Aufnahme beginnt in ${i?.seconds} Sekunde${i?.suffix}`)
};

const it_audio_recorder_recording_starts_in = /** @type {(inputs: Audio_Recorder_Recording_Starts_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La registrazione inizia tra ${i?.seconds} secondi${i?.suffix}`)
};

const ru_audio_recorder_recording_starts_in = /** @type {(inputs: Audio_Recorder_Recording_Starts_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Запись начинается через ${i?.seconds} секунду${i?.suffix}`)
};

const es_audio_recorder_recording_starts_in = /** @type {(inputs: Audio_Recorder_Recording_Starts_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La grabación comienza en ${i?.seconds} segundo${i?.suffix}`)
};

const zh_cn2_audio_recorder_recording_starts_in = /** @type {(inputs: Audio_Recorder_Recording_Starts_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`录制在${i?.seconds}秒${i?.suffix}开始`)
};

const ja_audio_recorder_recording_starts_in = /** @type {(inputs: Audio_Recorder_Recording_Starts_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`録音は${i?.seconds}秒後に開始されます${i?.suffix}`)
};

const hi_audio_recorder_recording_starts_in = /** @type {(inputs: Audio_Recorder_Recording_Starts_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`रिकॉर्डिंग ${i?.seconds} सेकंड${i?.suffix} में शुरू होती है`)
};

const pt_pt2_audio_recorder_recording_starts_in = /** @type {(inputs: Audio_Recorder_Recording_Starts_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A gravação começa em ${i?.seconds} segundo${i?.suffix}`)
};

/**
* | output |
* | --- |
* | "Recording starts in {seconds} second{suffix}" |
*
* @param {Audio_Recorder_Recording_Starts_InInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_recording_starts_in = /** @type {((inputs: Audio_Recorder_Recording_Starts_InInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Recording_Starts_InInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_recording_starts_in(inputs)
	if (locale === "de") return de_audio_recorder_recording_starts_in(inputs)
	if (locale === "it") return it_audio_recorder_recording_starts_in(inputs)
	if (locale === "ru") return ru_audio_recorder_recording_starts_in(inputs)
	if (locale === "es") return es_audio_recorder_recording_starts_in(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_recording_starts_in(inputs)
	if (locale === "ja") return ja_audio_recorder_recording_starts_in(inputs)
	if (locale === "hi") return hi_audio_recorder_recording_starts_in(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_recording_starts_in(inputs)
	return en_audio_recorder_recording_starts_in(inputs)
});